export class Suffix {
    constructor(){

    }
    static init(name){
        if(name.indexOf("jpg") > -1) {
            return ".jpg";
        } else if(name.indexOf("png") > -1) {
            return ".png";
        } else if(name.indexOf("gif") > -1) {
            return ".gif";
        } else if(name.indexOf("pdf") > -1) {
            return ".pdf";
        } else if(name.indexOf("jpg") > -1) {
            return ".jpg";
        } else if(name.indexOf("webp") > -1) {
            return ".webp";
        }
    }
}